/**
 * TanStack Query hooks for `quarterly-awards`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	quarterlyAwardsQueryKeys,
	type CreateQuarterlyAwardsBody,
	type ListQuarterlyAwardsResponse,
	type QuarterlyAwardsRow,
} from "./api";

export function useQuarterlyAwardsList(): UseQueryResult<ListQuarterlyAwardsResponse, Error> {
	return useQuery({
		queryKey: quarterlyAwardsQueryKeys.list(),
		queryFn: list,
	});
}

export function useQuarterlyAwardsCreate(): UseMutationResult<QuarterlyAwardsRow, Error, CreateQuarterlyAwardsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: quarterlyAwardsQueryKeys.all });
		},
	});
}

export function useQuarterlyAwardsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: quarterlyAwardsQueryKeys.all });
		},
	});
}
